import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M11.4941 18.4004C11.2136 18.1079 10.9952 17.7616 10.8522 17.3825C10.7092 17.0033 10.6445 16.5991 10.662 16.1943C10.6795 15.7894 10.7788 15.3923 10.954 15.0269C11.1291 14.6615 11.3765 14.3353 11.6812 14.0682C11.9859 13.801 12.3415 13.5983 12.7267 13.4723C13.1119 13.3464 13.5185 13.2998 13.9222 13.3353C14.3259 13.3708 14.7182 13.4878 15.0754 13.6791C15.4327 13.8704 15.7474 14.1321 16.0008 14.4484C16.2553 14.1354 16.5704 13.8769 16.9271 13.6885C17.2838 13.5001 17.6749 13.3855 18.0769 13.3517C18.4789 13.3179 18.8836 13.3656 19.2668 13.4918C19.65 13.618 20.0037 13.8202 20.307 14.0863C20.6102 14.3524 20.8567 14.6769 21.0316 15.0404C21.2065 15.4039 21.3063 15.799 21.325 16.202C21.3437 16.605 21.281 17.0077 21.1405 17.3858C21 17.764 20.7847 18.11 20.5074 18.403L17.0061 22.211C16.8812 22.3549 16.7268 22.4702 16.5535 22.5492C16.3802 22.6283 16.1919 22.6692 16.0014 22.6692C15.8109 22.6692 15.6227 22.6283 15.4493 22.5492C15.276 22.4702 15.1217 22.3549 14.9968 22.211L11.4941 18.4004Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		id: "Vector_2",
		d: "M4 13.3333C3.99991 12.9454 4.08445 12.5622 4.24772 12.2103C4.41099 11.8584 4.64906 11.5464 4.94533 11.296L14.2787 3.29599C14.76 2.8892 15.3698 2.66602 16 2.66602C16.6302 2.66602 17.24 2.8892 17.7213 3.29599L27.0547 11.296C27.3509 11.5464 27.589 11.8584 27.7523 12.2103C27.9156 12.5622 28.0001 12.9454 28 13.3333V25.3333C28 26.0406 27.719 26.7188 27.219 27.2189C26.7189 27.719 26.0406 28 25.3333 28H6.66667C5.95942 28 5.28115 27.719 4.78105 27.2189C4.28095 26.7188 4 26.0406 4 25.3333V13.3333Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgHome;
